import type { JSX, ReactNode } from "react";

import {
  Field,
  FieldContent,
  FieldError,
  FieldLabel,
} from "@frontend/components/atoms/Field";

export type FieldFrameProps = {
  label?: ReactNode;
  error?: string | null;
  children: ReactNode;
};

/** The label and the error, or nothing at all when the caller lays it out. */
export function FieldFrame({
  label,
  error,
  children,
}: FieldFrameProps): JSX.Element {
  if (undefined === label) {
    return <>{children}</>;
  }

  return (
    <Field invalid={Boolean(error)}>
      <FieldLabel>{label}</FieldLabel>

      <FieldContent>
        {children}

        <FieldError match={Boolean(error)}>{error}</FieldError>
      </FieldContent>
    </Field>
  );
}
